import { queries } from "../../shared/queries";
import {
  findLockingSyncMode,
  type IdpOwnedConcern,
} from "../../shared/rbac/validation/idpSyncLock";
import { useQuery } from "@rocicorp/zero/react";

export type IdpSyncLock = { locked: boolean; reason: string | null };

function lockReason(syncMode: string): string {
  const via = syncMode === "scim" ? "SCIM provisioning" : "SSO sync (JIT)";
  return `Managed by your identity provider via ${via}. Disable sync in SSO settings to make changes.`;
}

// Mirrors assertIdpSyncNotActive: `reason` names the active mode so a disabled
// control can explain itself on hover.
export function useIdpSyncLock(concern: IdpOwnedConcern): IdpSyncLock {
  const [providers] = useQuery(queries.ssoProviders());
  const lockingMode = findLockingSyncMode(providers, concern);
  if (lockingMode == null) return { locked: false, reason: null };
  return { locked: true, reason: lockReason(lockingMode) };
}
